export class BackToTopButtonController {

    public static $inject: string[] = [
        "$scope"
    ];

    public showBtnScroll: boolean = false;
    public backToTopTarget: any;

    constructor(
        private $scope
    ) {}

    public $onInit() {
        this._checkScrollDown();
    }

    /**
     * method to call with btn "back to top"
     */
      public scrollTop() {
        this.backToTopTarget.scrollTop = 0;
    }

    /**
     * handler show button "back to top"
     * @private
     */
    public _checkScrollDown() {
        this.backToTopTarget.addEventListener( "scroll",  () => {
            if (this.backToTopTarget.scrollTop >= 160 && !this.showBtnScroll) {
                this.$scope.$apply( () => this.showBtnScroll = true);
            }
            if (this.backToTopTarget.scrollTop < 160 && this.showBtnScroll) {
                this.$scope.$apply( () => this.showBtnScroll = false);
            }
        });
    }
}
